import React, { useCallback, useEffect, useState } from "react";
import images from "../../../constant/images";
import { Nav } from "../../../layouts/navbar/nav";
import Sidebar from "../../../layouts/sidebar/sidebar";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function Felecitation() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  const [user, setUser] = useState(null);
  const [membershipPack, setMembershipPack] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const location = useLocation();
  const navigate = useNavigate();
  const { pack, id } = location.state || {}; // Ensure `pack` and `id` are safely accessed

  // Fetch user and membership pack data
  const fetchData = useCallback(async () => {
    try {
      const token = localStorage.getItem("userToken");
      if (token) {
        // Fetch user data
        const userResponse = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(userResponse.data);
        setMembershipPack(userResponse.data.membership.membership_packs.description);
        // Fetch membership pack data
        if (id) {
          const packResponse = await axios.get(`${baseUrl}/packs/${id}`);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  // Navigate to another page after 5 seconds

  if (isLoading) {
    return (
      <div
        className="loader h-[100vh] flex justify-center items-center"
        style={{
          backgroundImage: `url(${images.golf_field})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="spinner"></div>
      </div>
    );
  }
  return (
    
          <div className="bg-white shadow-custom bg-opacity-[87%] h-full flex flex-col justify-start items-center p-6 md:p-16 gap-4 md:gap-8 w-full md:w-[100%] rounded-3xl py-12 md:py-24">
            <div className="text-center text-2xl md:text-4xl font-bold mb-2 md:mb-3">
              <p>🎉 {t("congratulations.title")}</p>
            </div>
            <div className="text-center flex flex-col gap-4 md:gap-7 leading-relaxed md:leading-loose">
              <span className="font-bold text-lg md:text-xl">
                {t("congratulations.account_activated")} {membershipPack} {language === "fr" ? "" : "Pack"}.
              </span>
              <span className="text-sm md:text-base">
                {t("congratulations.p1")}{" "}
                <span className="font-bold">{membershipPack}</span> {language === "fr" ? "" : "Pack"}!{" "}
                {t("congratulations.benefits")}
              </span>
              <span className="text-sm md:text-base">
                {t("congratulations.unique_experience")}
              </span>
              <span className="text-xl md:text-3xl font-bold mt-6 md:mt-12">
                ✨ {t("congratulations.welcome")} ✨
              </span>
            </div>
          </div>
      
  );
}
